import { createGlobalStyle } from "styled-components";
import styled from "styled-components";
import { devices } from "./responsive";

const GlobalStyle = createGlobalStyle`
    :root {
        --primary: #5062CD;
        --primary-on-hover: #2098B1;
        --background-color: #FBFBFB;

        --primary-paragraph-color: #4260D1;
        --secondary-paragraph-color: #000;
        --eyebrow-color: #47c2db;
        --dark: #20232A;
        --white: #fff;
        --light-grey: #A8A8A8;
        --lighter-gray: #d6d2d2;
        --green: #C5E28C;
        --heavenly: #1795D3;
        --azure: #365BE5;
        --grey: #3C3F48;
        --transparent: trasparent;
    }
  
    *,
    *::before,
    *::after {
        margin: 0;
        padding: 0;
        box-sizing: inherit;
    }

    html {
        font-size: 62.5%;
        font-family: 'Nunito Sans', sans-serif;
        background-color: var(--background-color);
        overflow: hidden;
        scroll-behavior: smooth;
    }

    body {
        box-sizing: border-box;
        position: relative;
        background-color: var(--dark);
        color: var(--white);
        font-size: 19px;
        line-height: 1.2;
        font-weight: 300;
        font-family: 'Nunito Sans',sans-serif;
    }

    #root {
        position: relative;
        /* overflow: hidden; */
    }

    #website {
        padding-top: 8em;
        min-height: 100vh;
        position: relative;
        display: flex;
        flex: 1;
        flex-direction: column;
    }

    ul.default {
        list-style: none;
        margin: 0;
    }

    ul {
        list-style-type: disc;
        margin-left: 4em;
        padding: 1em 0;

        li {
            font-size: 1.9rem;
            line-height: 1.5;
            font-weight: 300;
            padding-left: 1rem;
        }
        
    }

    .nav__links {
        ul {
            list-style: none;
            li {
                padding-left: 0;
            }
        }
    }

    ol {
        color: var(--white);
        margin-left: 4em;
        padding: 2em 0;

        li {
            padding-left: 1rem;
            font-size: 1.9rem;
            line-height: 1.5;
            font-weight: 300;
            color: var(--white);
        }
    }
    
    h1 {
        font-size: 4.7rem;
        line-height: 1.2;
        font-weight: 800;
        color: var(--white);

        @media ${devices.phoneLg} {
            font-size: 3.2rem;
            line-height: 3.6rem;
        }
    }

    h2 {
        font-size: 3.9rem;
        line-height: 1.2;
        font-weight: 600;
        color: var(--eyebrow-color);
        margin: 1em 0;
    }

    h3 {
        font-size: 2.3rem;
        line-height: 1.2;
        font-weight: 700;
        color: var(--eyebrow-color);
        margin: 1em 0 0.5em;
        text-transform: uppercase;
        letter-spacing: 2px;

        &.normal {
            text-transform: none;
        }

        &.title, 
        .card__title {
            font-size: 3.2rem;
            text-transform: none;
            color: var(--white);
            margin-bottom: 0;
            letter-spacing: 0;
        }
    }

    h4 {
        font-size: 2.2rem;
        line-height: 1.2;
        font-weight: 600;
        color: var(--white);
        margin: 1em 0 0.5em;
    }

    h5 {
        font-size: 2.1rem;
        line-height: 1.2;
        font-weight: 500;
        color: var(--white);
        margin: 1em 0 0.5em;
    }

    h6 {
        font-size: 2rem;
        letter-spacing: 2px;
        line-height: 1.5;
        font-weight: 600;
        color: var(--light-grey);
        text-transform: uppercase;
        margin: 1em 0 0.5em;
    }

    p {
        font-size: 2rem;
        line-height: 1.5;
        letter-spacing: .5px;
        font-weight: 300;

        &.pullquote {
            display: flex;
            align-content: center;
            align-items: center;

            span {
                font-size: 2.3rem;
                font-weight: 500;
                font-style: italic;
                line-height: 1.1;
            }

            &::before {
                content: open-quote;
                font-size: 100px;
                font-weight: 600;
                padding: 0 13px;
                display: inline-block;
                margin-top: 40px;
            }
        }

        &.highlight span {
            background-color: var(--green);
            color: var(--dark);
            font-weight: 700;
            padding: 0 3px;
        }
    }

    a {
        position: relative;
        text-decoration: none;
        color: var(--primary);
         .title:hover{
             color: var(--primary-on-hover);
         }  
        @include respond(desktop-lg) {
            font-size: 2rem;
        }

 
    }

    video {
        width: 100%;
    }

    .image-responsive,
    .responsive {
        width: 100%;
        height: auto;
    }

    .active {
        color: var(--eyebrow-color);
    }
    
    .read-time {
        font-size: 14px;
        font-weight: 300;
        color: var(--light-grey);
        margin-left: 1em;
        position: relative;
        padding-left: 20px;

        &::before {
            content: '';
            width: 5px;
            height: 5px;
            background-color: var(--light-grey);
            border-radius: 50%;
            display: inline-block;
            position: absolute;
            top: 5px;
            left: 0;
        }
    }

    .article__wrapper {

    }

    pre.code {
        background-color: #1A1C22;
        border: 1px solid #3C4048;
        border-radius: 16px;
        padding: 20px;
        margin: 20px 0;
        tab-size: 2;
        font-family: 'Courier New', Courier, Lucida Typewriter,monospace; 
        white-space: pre-wrap;
        line-height: 0.9;
        font-size: 17px;
        overflow-x: auto;

        p {
            color: var(--white);
        }
        .hljs-tag {
            line-height: 1.25;
        }
        &.hljs {
            background: #1E1E1E;
            color: #DCDCDC;

            .hljs-keyword,
            .hljs-literal,
            .hljs-symbol,
            .hljs-name {
                color: #569CD6
            }
            .hljs-link {
                color: #569CD6;
                text-decoration: underline
            }
            .hljs-built_in,
            .hljs-type {
                color: #4EC9B0
            }
            .hljs-number,
            .hljs-class {
                color: #B8D7A3
            }
            .hljs-string,
            .hljs-meta .hljs-string {
                color: #D69D85
            }
            .hljs-regexp,
            .hljs-template-tag {
                color: #9A5334
            }
            .hljs-subst,
            .hljs-function,
            .hljs-title,
            .hljs-params,
            .hljs-formula {
                color: #DCDCDC
            }
            .hljs-comment,
            .hljs-quote {
                color: #57A64A;
                font-style: italic
            }
            .hljs-doctag {
                color: #608B4E
            }
            .hljs-meta,
            .hljs-meta .hljs-keyword,
            .hljs-tag {
                color: #9B9B9B
            }
            .hljs-variable,
            .hljs-template-variable {
                color: #BD63C5
            }
            .hljs-attr,
            .hljs-attribute {
                color: #9CDCFE
            }
            .hljs-section {
                color: gold
            }
            .hljs-emphasis {
                font-style: italic
            }
            .hljs-strong {
                font-weight: bold
            }
            /*.hljs-code {
            font-family:'Monospace';
            }*/
            .hljs-bullet,
            .hljs-selector-tag,
            .hljs-selector-id,
            .hljs-selector-class,
            .hljs-selector-attr,
            .hljs-selector-pseudo {
                color: #D7BA7D
            }
            .hljs-addition {
                background-color: #144212;
                display: inline-block;
                width: 100%
            }
            .hljs-deletion {
                background-color: #600;
                display: inline-block;
                width: 100%
            }       
        }

        &.hljs.bg-light {
            background: white;
            color: black;

            .hljs-comment,
            .hljs-quote,
            .hljs-variable {
                color: #008000
            }
            .hljs-keyword,
            .hljs-selector-tag,
            .hljs-built_in,
            .hljs-name,
            .hljs-tag {
                color: #00f
            }
            .hljs-string,
            .hljs-title,
            .hljs-section,
            .hljs-attribute,
            .hljs-literal,
            .hljs-template-tag,
            .hljs-template-variable,
            .hljs-type,
            .hljs-addition {
                color: #a31515
            }
            .hljs-deletion,
            .hljs-selector-attr,
            .hljs-selector-pseudo,
            .hljs-meta {
                color: #2b91af
            }
            .hljs-doctag {
                color: #808080
            }
            .hljs-attr {
                color: #f00
            }
            .hljs-symbol,
            .hljs-bullet,
            .hljs-link {
                color: #00b0e8
            }
            .hljs-emphasis {
                font-style: italic
            }
            .hljs-strong {
                font-weight: bold
            }
        }
    }

    .flex {
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: flex-start;
    }

    .flex-wrap {
        flex-wrap: wrap;
    }

    .space-between {
        justify-content: space-between;
    }

    .two-col {
        display: flex;
        flex-wrap: wrap;

        .col {
            width: 100%;

            @media screen and (min-width: 64em) {
                width: 50%;
            }
        }
    }

    .login-btn {
        border: none;
        border-radius: 100px;
        padding: 12px 32px;
        background: var(--primary);
        color: var(--white);
        transition: all .3s ease;
        cursor: pointer;

        &:hover {
            background: var(--primary-on-hover);
        }

        &:focus {
            outline: none;
        }
    }
      
      .trigger {
        display: none;
      }
      
      .slider, .slider-wrapper {
        position: relative;
        min-height: 250px;

        &.figure-contain {
            min-height: auto;

            .slide-figure  img {
                width: 100%;
                height: 100%;
                object-fit: contain;
             }
        }
      }
      
      .slide {
        background-color: transparent;
        width: 100%;
        overflow: hidden;
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 5000;
        opacity: 0;
        transition: opacity .5s ease-in-out;

        &-img {
            filter: brightness(50%);
            height: 100%;
            object-fit: fill;
            display: block;
            margin: 0 auto;
        }

        &-figure {
            height: 100%;
            position: relative;
            margin: 0;
    
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
             }
             
        }

        &-caption {
            position: absolute;
            bottom: 8%;
            width: 100%;
            color: white;
            text-align: left;
            font-weight: 600;
            left: 1em;
            background-color: rgb(0 0 0 / 32%);
            vertical-align: middle; 
            p {
                margin: 0;
                padding: 3px;
                font-weight: 600;
            }
        }

      }
      
    
      .trigger:checked + .slide {
        z-index: 6000;
        opacity: 1;
      }
      
      .slider-nav {
        width: 100%;
        text-align: center;
        margin: 1rem 0;

        &__item {
            display: inline-block;
        }

        &__label {
            font-size: 13px;
            background-color: white;
            display: block;
            height: 2em;
            line-height: 2em;
            width: 2em;
            text-align: center;
            border-radius: 50%;
            color: transparent;
            cursor: pointer;
            transition: background-color .25s, color .25s ease-in-out;

            &:hover,
            &:active,
            &:focus {
                background-color: var(--green);
            }

        }
      }
    

      @media only screen and (min-width: 1024px) {
        .slider, .slider-wrapper {
          min-height: 420px;
        }
      
        .slide-caption {
          width: auto;
          font-size: 1.5rem;
        }
      }
      
      @media only screen and (max-width: 1023px) and (min-width: 768px) {
        .slider, .slider-wrapper {
          height: 360px;
        }
      
        .slide-caption {
          width: 75%;
          font-size: 1.25rem;
        }
      }
      
      @media only screen and (min-width: 768px) {
        .slide-img {
          width: 100%;
          height: auto;
        }
      }

    //   Reponsive tables

    .responsive-table {
        width: 100%;
        margin-bottom: 1.5em;

        thead {
            position: absolute;
            clip: rect(1px 1px 1px 1px);
            /* IE6, IE7 */
            clip: rect(1px, 1px, 1px, 1px);
            padding: 0;
            border: 0;
            height: 1px;
            width: 1px;
            overflow: hidden;

            th {
                background-color: #1d96b2;
                border: 1px solid #1d96b2;
                font-weight: normal;
                text-align: center;

                &:first-of-type {
                    text-align: left;
                }
            }
        }

        tbody,
        tr,
        th,
        td {
            display: block;
            padding: 0;
            text-align: left;
            white-space: normal;
        }

        th,
        td {
            padding: .5em;
            vertical-align: middle;
        }

        caption {
            margin-bottom: 1em;
            font-size: 1em;
            font-weight: bold;
            text-align: center;
        }

        tfoot {
            font-size: .8em;
            font-style: italic;
        }
    
          
        tbody {
            tr {
                margin-bottom: 1em;
                border: 2px solid #1d96b2;
                &:last-of-type {
                    margin-bottom: 0;
                }
            }

            th[scope="row"] {
                background-color: #1d96b2;
                color: white;
            }

            td[data-type=currency] {
                text-align: right;
            }

            td[data-title]:before {
                content: attr(data-title);
                float: left;
                font-size: .8em;
                color: rgba(94, 93, 82, 0.75);
            }

            .td {
                text-align: right;
                border-bottom: 1px solid #1d96b2;
            }
        }
    }
      
    @media (min-width: 52em) {
        .responsive-table {
            font-size: .9em;
            
            thead {
                position: relative;
                clip: auto;
                height: auto;
                width: auto;
                overflow: auto;
            }

            tr {
                display: table-row;
            }
            th,
            td {
                display: table-cell;
                padding: .5em;
            }
            caption {
                font-size: 1.5em;
            }
            tbody {
                display: table-row-group;

                tr {
                    display: table-row;
                    border-width: 1px;
                    &:nth-of-type(even) {
                        background-color: rgba(94, 93, 82, 0.1);
                        }
                }
            }
        }
        .responsive-table tbody th[scope="row"] {
            background-color: transparent;
            text-align: left;
        }
        .responsive-table tbody td {
            text-align: center;
        }
        .responsive-table tbody td[data-title]:before {
            content: none;
        }
    }

    @media (min-width: 62em) {
        .responsive-table {
            font-size: 1em;
        }
        .responsive-table th,
        .responsive-table td {
            padding: .75em .5em;
        }
        .responsive-table tfoot {
            font-size: .9em;
        }
    }
      
    @media (min-width: 75em) {
        .responsive-table th,
        .responsive-table td {
            padding: .75em;
        }
    }
    /* id case-study points at white background's pages */
    #case-study {
        background-color: var(--white);
        color: black;
        font-size: 1.9rem;
        line-height: 1.5;
        letter-spacing: 0.5px;
        font-weight: 300;

        #website {
            padding-top: 10em;
        }

        .responsive-table {
            thead  th {
                color: var(--white);
            }
            tbody {
                tr th {
                    color: var(--black);
                    
                }
            }
        }

        h1,
        h2,
        h3,
        h4,
        h5 {
            color: var(--primary);
        }

        
        p,
        span {
            color: black;
        }

        .primary {
            h1,
            h2,
            h3,
            h4
            h5,
            span {
                color: var(--primary);
            }
        }

        section {
            margin: 4em auto;
        }

        ul.list-circle, 
        ol  {
            color: black;
            li {
                color: black;
            }
        }

        a {
            color: var(--primary);
            font-weight: 600;
            .title:hover{
                color:var(--primary-on-hover);
            }
            &.category {
                color: var(--white);
            }

            span {
                color: var(--primary);
                font-weight: 600;
            }
            &.btn-method,
            &.btn-continue {
                border: none;
                background-color: var(--primary);
                border-radius: 30px;
                color: var(--white);
                font-size: 1.6rem;
                font-weight: 600;
                padding: 12px 32px;
                margin: 10px 0;
                text-align: center;
                width: calc(50% - 10px);
                transition: all .3s ease;
                cursor: pointer;

                &:hover {
                    background-color: var(--primary-on-hover);
                }
            }

            &.btn-continue {
                width: auto;
                border-radius: 4px;
            }
        }

        .nav__links ul li a {
            color: var(--primary);
        }
        
        h6 {
            color: #707070;
        }
        .tag {
            color: black;
           &:hover{
             color: var(--primary-on-hover)!important;
         }  

        }

        
        .read-time,
        .date {
            color: #818181;
        }
        .author-name {
            color: black;
        }

        footer ul {
            .linkedInIcon svg {
                rect {
                    fill: #0077b5;
                }
            }

            .facebookIcon svg {
                rect {
                    fill: #4267B2;
                }
            }
        }

        .wrapper {
            width: 100%;

            img {
                max-width: 500px;

                @media ${devices.phoneLg} {
                    width: 100%;
                    height: 100%;
                    margin: 0;
                    order: -1;
                }
            }

            @media ${devices.tabletPortrait} {
                flex-direction: column;
            }
        }

        .mtl-col {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .col {
            display: flex;
            flex-direction: column;
            flex-basis: 100%;
            flex: 1;
        }

        .client-info {
            @media ${devices.phoneLg} {
                text-align: center;
            }

            .info {
                @media ${devices.tabletPortrait} {
                    margin: 24px auto;
                }
            }

            .icon {
                svg {
                    width: 48px;
                    height: 48px;
                    fill: var(--primary);
                }
            }

            .text {
                display: flex;
                align-items: baseline;
                flex-direction: column;
                font-size: 16px;
                font-weight: 400;
                margin-left: .8rem;
                color: var(--primary);

                span {
                    font-weight: 700;
                    color: var(--primary);
                    font-size: 2.4rem;

                    &:before {
                        content: '>';
                    }
                }
            }
        }

        .icons {
            img {
                max-height: 80px;
            }
        }
        .grid-2,
        .grid-3,
        .grid-4 {
            display: grid;
            align-items: center;
            justify-items: center;
            gap: 24px;
        }

        .grid-2 {
            grid-template-columns: repeat(2, 1fr);

            @media ${devices.phoneLg} {
                grid-template-columns: 100%;
            }
        }

        .grid-3 {
            grid-template-columns: repeat(3, 1fr);

            @media ${devices.phoneLg} {
                grid-template-columns: 100%;
            }
        }

        .grid-4 {
            grid-template-columns: repeat(4, 1fr);

            @media ${devices.phoneLg} {
                grid-template-columns: 100%;
            }
        }

        .centered {
            text-align: center;
        }

        .challenge {
            border: 2px solid #E1F2D9;
            padding: 30px;
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            @media ${devices.tabletPortrait} {
                flex-direction: column;
            }

            &:not(:last-child) {
                margin-bottom: 32px;
            }

            .content {
                display: flex;
                flex-direction: column;
                flex-basis: 100%;
                flex: 1;

                @media ${devices.phoneLg} {
                    width: 100%;
                }

                .challenge-title {
                    color: var(--primary) !important;
                }
            }
        }
        

        
        .reverse-order {
            img {
                order: -1;
            }
        }

        .case-study-img {
            width: 100%;
        }

        .m-8 {
            margin: 8px;
        }
        .m-16 {
            margin: 16px;
        }
        .m-24 {
            margin: 24px;
        }
        .m-32 {
            margin: 32px;
        }
        .m-48 {
            margin: 48px;
        }
        .m-64 {
            margin: 64px;
        }

        .mt-8 {
            margin-top: 8px;
        }
        .mt-16 {
            margin-top: 16px;
        }
        .mt-24 {
            margin-top: 24px;
        }
        .mt-32 {
            margin-top: 32px;
        }
        .mt-48 {
            margin-top: 48px;
        }
        .mt-64 {
            margin-top: 64px;
        }

        .mb-8 {
            margin-bottom: 8px;
        }
        .mb-16 {
            margin-bottom: 16px;
        }
        .mb-24 {
            margin-bottom: 24px;
        }
        .mb-32 {
            margin-bottom: 32px;
        }
        .mb-48 {
            margin-bottom: 48px;
        }
        .mb-64 {
            margin-bottom: 64px;
        }

        .ml-8 {
            margin-left: 8px;
        }
        .ml-16 {
            margin-left: 16px;
        }
        .ml-24 {
            margin-left: 24px;
        }
        .ml-32 {
            margin-left: 32px;
        }
        .ml-48 {
            margin-left: 48px;
        }
        .ml-64 {
            margin-left: 64px;
        }

        .mr-8 {
            margin-right: 8px;
        }
        .mr-16 {
            margin-right: 16px;
        }
        .mr-24 {
            margin-right: 24px;
        }
        .mr-32 {
            margin-right: 32px;
        }
        .mr-48 {
            margin-right: 48px;
        }
        .mr-64 {
            margin-right: 64px;
        }

        .network__numbers__data {
            margin-top: 5rem;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: center;
        }

        .network__numbers__data .single__data {
            display: flex;
            align-items: center;
            padding: 3rem 2rem;
            border-radius: 5rem .5rem 5rem .5rem;
            transition: all .3s ease;
        }

        .network__numbers__data .single__data:not(:last-child) {
            margin-right: 2rem;
        }

        .network__numbers__data .single__data:hover {
            transform: scale(1.05);
            box-shadow: 0 2rem 3rem rgb(0 0 0 / 10%);
            background-color: white;
        }

        .network__numbers__data .single__data .text {
            display: flex;
            align-items: baseline;
            flex-direction: column;
            font-size: 1.6rem;
            font-weight: 400;
            margin-left: .8rem;
        }

        .network__numbers__data .single__data:hover .text span {
            color: #2098b1;
        }

    }
`;

export const Flex = styled.div<{
  alignItems?: string;
  justifyContent?: string;
  flexDirection?: string;
  margin?: number[];
}>`
  display: flex;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "intial")};
  justify-content: ${({ justifyContent }) =>
    justifyContent ? justifyContent : "intial"};
  margin: ${({ margin }) => margin && margin.map((m) => `${m}px`).join(" ")};
  flex-direction: ${({ flexDirection }) =>
    flexDirection ? flexDirection : "row"};

  @media ${devices.tabletPortrait} {
    flex-wrap: wrap;
  }
`;

export default GlobalStyle;
